<template>
  <div>
    <div class="main-content">
      <div class="section__content section__content--p30">
        <div class="container-fluid">
          <v-card max-width="1024">
            <v-card-title class="headline m-l-25">
              {{ user.username }}
            </v-card-title>
            <v-card-text>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="p-l-10">
                    <strong>{{ text('name') }}:</strong>
                    {{ user.name }}
                  </v-list-tile-title>
                  <v-list-tile-title class="p-l-10">
                    <strong>{{ text('company') }}:</strong>
                    {{ user.company || 'N/A'}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-card-text>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link :to="{name: 'ProfileEditPage'}" tag="a">
                  <i class="fa fa-edit p-r-10"></i>{{ text('edit_profile_btn') }}
                </router-link>
              </li>
              <li class="list-group-item">
                <router-link :to="{name: 'ChangePasswordPage'}" tag="a">
                  <i class="fa fa-key p-r-10"></i>{{ text('change_my_password') }}
                </router-link>
              </li>
            </ul>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.getters.user || {};
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
